import React, { useContext, useState, useEffect } from "react";

import { useOrder } from "./OrderContext";
import { useAuth } from "./AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const shippingContext = React.createContext();

export function useShipping() {
  return useContext(shippingContext);
}

export function ShippingProvider({ children }) {
  const [shippingInfo, setShippingInfo] = useState(null);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const { currentUser, logout } = useAuth();
  const { cartId, setStatus, setCartInfo, status } = useOrder();

  useEffect(() => {
    if (!currentUser) {
      sessionStorage.removeItem("shipping");
      setShippingInfo({
        deliverType: "",
        deliverInfo: "",
      });
      return;
    }
    const info = sessionStorage.getItem("shipping");
    if (!info) {
      setShippingInfo({
        deliverType: "",
        deliverInfo: "",
      });
    } else {
      setShippingInfo(JSON.parse(info));
    }
  }, [currentUser]);

  const navigate = useNavigate();

  const condition = status === 3;

  useEffect(() => {
    const checkSubmitTime = setInterval(() => {
      if (!condition || !currentUser) return clearInterval(checkSubmitTime);
      const time = localStorage.getItem("submitTime");
      if (!time) return;
      const currentTime = new Date();
      //1200000
      const differece = currentTime - new Date(time);

      if (differece >= 1200000) {
        localStorage.removeItem("submitTime");
        cancelOrder();
        setIsPaymentOpen(false);
        clearInterval(checkSubmitTime);
      }
    }, 5000);
    return () => clearInterval(checkSubmitTime);
  }, [condition]);

  function addDeliveryInfo(type, info) {
    const oldInfo = shippingInfo;
    const newInfo = {
      ...oldInfo,
      deliverType: type,
      deliverInfo: info,
    };
    setShippingInfo(newInfo);
    sessionStorage.setItem("shipping", JSON.stringify(newInfo));
  }

  async function inHomeSubmit(address, coords) {
    const dataToSend = {
      cartId: cartId,
      deliverType: "HOME",
      home_information: {
        latitude: coords[0],
        longitude: coords[1],
        address_text: address,
      },

      locationId: 1,
    };

    await fetch("https://api.redfoxcafe.ir/v1/client/set-shipping/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          setStatus(3);
          setIsPaymentOpen(true);
          localStorage.setItem("submitTime", JSON.stringify(new Date()));
        } else if (d.status === "401") {
          toast.info(d.message);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }

  async function inCafeSubmit(number) {
    const dataToSend = {
      cartId: cartId,
      deliverType: "CAFE",
      table_id: number,
      locationId: 1,
    };

    await fetch("https://api.redfoxcafe.ir/v1/client/set-shipping/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          setStatus(3);
          setIsPaymentOpen(true);
          localStorage.setItem("submitTime", JSON.stringify(new Date()));
        } else if (d.status === "401") {
          toast.info(d.message);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }

  async function submitShipping(loc_id) {
    let dataToSend = {
      cartId: cartId,
      deliverType: shippingInfo.deliverType,
    };

    if (shippingInfo.deliverType === "CAR") {
      dataToSend = {
        ...dataToSend,
        car_information: shippingInfo.deliverInfo,
        locationId: loc_id,
      };
    } else if (shippingInfo.deliverType === "BYCE") {
      dataToSend = {
        ...dataToSend,
        byce_information: shippingInfo.deliverInfo,
        locationId: loc_id,
      };
    } else if (shippingInfo.deliverType === "FOOT") {
      dataToSend = {
        ...dataToSend,
        ...shippingInfo.deliverInfo,
        locationId: loc_id,
      };
    } else {
      dataToSend = {
        ...dataToSend,
        ...shippingInfo.deliverInfo,
        locationId: 1,
      };
    }

    await fetch("https://api.redfoxcafe.ir/v1/client/set-shipping/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((d) => {
        console.log(d);
        if (d.status === "200") {
          getPaymentLink();
        } else if (d.status === "401") {
          toast.info(d.message);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }

  async function getPaymentLink() {
    const dataToSend = {
      payment_type: "invoice",
      invoice_id: cartId,
      price: "0",
    };
    await fetch("https://api.redfoxcafe.ir/v1/client/create-payment/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          window.location.href = d.data;
        } else if (d.status === "401") {
          toast.info(d.message);
          logout();
          navigate("/login", { replace: true });
        }
      });
  }

  async function cancelOrder() {
    const updateCart = async () => {
      fetch("https://api.redfoxcafe.ir/v1/client/active-cart/", {
        method: "GET",
        headers: {
          "Authorization-Token": "Bearer " + currentUser.access_token,
        },
      })
        .then((response) => response.json())
        .then((d) => {
          if (d.status === "200") {
            const newInfo = {
              cartId: d.data.CartId,
              products: d.data.CartDetails ? d.data.CartDetails : [],
              status: d.data.CartStatusNumber ? d.data.CartStatusNumber : 0,
              matched: true,
            };

            setCartInfo(newInfo);
          } else {
            toast.error(d.message);
          }
        });
    };

    await fetch("https://api.redfoxcafe.ir/v1/client/cancel-order/", {
      method: "GET",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          updateCart();
        } else if (d.status === "401") {
          toast.info(d.message);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }

  const closePaymentWindow = () => setIsPaymentOpen(false);
  const openPaymentWindow = () => setIsPaymentOpen(true);
  const allowLocation = () =>
    shippingInfo.deliverType !== "" && shippingInfo.deliverInfo !== "";

  const isFetching = () => shippingInfo === null;

  const info = {
    addDeliveryInfo,
    submitShipping,
    closePaymentWindow,
    openPaymentWindow,
    getPaymentLink,
    allowLocation,
    isFetching,
    inCafeSubmit,
    inHomeSubmit,
    isPaymentOpen,
    cancelOrder,
  };
  return (
    <shippingContext.Provider value={info}>{children}</shippingContext.Provider>
  );
}
